import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { WindowrefService } from '../../services/windowref/windowref.service';
import { RouterLink } from '@angular/router';
import { NgFor, NgClass, NgIf, NgTemplateOutlet, NgStyle } from '@angular/common';
import { IonicModule } from '@ionic/angular';

/**
 * Generated class for the ContentstripesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    styleUrls: ['./contentstripes.scss'],
    selector: 'contentstripes',
    templateUrl: 'contentstripes.html',
    standalone: true,
    imports: [IonicModule, NgFor, NgClass, NgIf, NgTemplateOutlet, NgStyle, RouterLink]
})
export class ContentstripesComponent implements OnInit, OnChanges{
  @Input() stripedata;
  @Input() community;
  isDarkMode;

  constructor(
    public windowRef: WindowrefService,
  ) { }

  ngOnInit() {
    this.isDarkMode = this.windowRef.isDarkMode();
    // Affordable icon in dark mode
    // if (this.isDarkMode && this.data.firstCol.img == 'assets/imgs/homepage/graphic-affordable2.svg') {
    //   this.data.firstCol.img = 'assets/imgs/homepage/graphic-affordable2-darkmode.svg'
    // }
  }

  ngOnChanges() {
    if (this.stripedata && this.community && this.community.state) {
      this.stripedata = this.stripedata.filter((stripe) => {
        if (stripe.hideincommunities && stripe.hideincommunities.includes(this.community.state)) return false;
        else return true;
      })
    }
  }

  evalPadding(index, length) {
    if (index === 0) return "overview-rowpadding-top";
    else if (index === length - 1) return "overview-rowpadding-bottom";
    else return "overview-rowpadding-middle"
  }
}
